const DeliveryStatuses = {
  DELIVERY_STATUS_CREATED: '0',
  DELIVERY_STATUS_OUT_FOR_DELIVERY: '1',
  DELIVERY_STATUS_DELIVERED: '2',
  DELIVERY_STATUS_DELETED: '3'
};

DeliveryStatuses.install = function (Vue) {
    Vue.prototype.$getConstDeliveryStatus = (key) => {
        return DeliveryStatuses[key];
    }
}

export default DeliveryStatuses;
